import { ExplorerItem } from "@/models/explorer.item";

const cold_case_unit = new ExplorerItem({
  title: "Cold Case Unit",
  selected_difficulty: ["easy", "medium", "hard"],
  episode: "001",
  type: "folder",
  icon: "Shell3221",
  iconProps: {
    variant: "32x32_4",
  },
  iconPropsDesktop: {
    css: {
      size: "3.8rem",
    },
  },
  iconPropsStartMenu: {
    css: {
      size: "3.2rem",
    },
  },
});


const papierkorb = new ExplorerItem({
  title: "Papierkorb",
  selected_difficulty: ["easy", "medium", "hard"],
  episode: "001",
  type: "folder",
  icon: "RecycleFull",
  iconProps: {
    variant: "32x32_4",
    css: {
      size: "3rem",
    },
  },
});




// DNA Abgleich
const dna_lookup = new ExplorerItem({
  title: "DNA Database",
  selected_difficulty: ["easy", "medium", "hard"],
  episode: "001",
  type: "dna.registry",
  icon: "Computer",
  iconProps: {
    variant: "32x32_4",
    css: {
      size: "3rem",
    },
  },

  dna_config: {
    prefix_type: "string",
    postfix_type: "numbers",
    separator: "-",
    prefix_digits: 3,
    postfix_digits: 8,
  },

  dna_sample_index: [
    {
      prefix: "HLP",
      postfix: "95469272",
      pre_entered: false,
      password: null,
      message: "Ergebnis: Weibliche Person & Keine Übereinstimmung mit Vergleichsprofil E. Whitmore",
    },
  ]

});




// Children of cold_case_unit

//verhör bauarbeiter
const interview_builders = new ExplorerItem({
  title: "Befragung Bauarbeiter",
  selected_difficulty: ["easy", "medium", "hard"],
  episode: "001",
  type: "mp4",
  imageUrl: "/resources/videos/tc1_befragung_bauarbeiter.mp4",
  icon: "Progman19",
  iconProps: {
    variant: "32x32_4",
    css: {
      size: "2.6rem",
    },
  },
  parent: cold_case_unit.id,
});


//befragungsprotokoll eltern
const interview_parents_whitmore = new ExplorerItem({
  title: "Befragung Eltern.jpg",
  selected_difficulty: ["easy", "medium", "hard"],
  episode: "001",
  type: "pdf",
  imageUrl: "/resources/documents/tc1_befragung_eltern_whitmore.pdf",
  icon: "FileText",
  iconProps: {
    variant: "32x32_4",
    css: {
      size: "2.6rem",
    },
  },
  parent: cold_case_unit.id,
});



//Übersicht polizisten?
const police_team_yearbook = new ExplorerItem({
  title: "Polizei Team.jpg",
  selected_difficulty: ["easy", "medium", "hard"],
  episode: "001",
  type: "image",
  imageUrl: "/resources/images/tc1_police_team_yearbook.jpg",
  icon: "Wangimg128",
  iconProps: {
    variant: "32x32_4",
    css: {
      size: "2.6rem",
    },
  },
  parent: cold_case_unit.id,
});


// Suchleiste
//  Elena Whitmore oder St. Marlowe Medical Center -> Anzeige gegen Sally Parker (pdf)
//  Pre-entered: „Gestohlene Waffen“ 1986 (pdf)
//  Pre-entered: „Foto Bank Tom Ellington“ (jpg)

const search_bar = new ExplorerItem({
  title: "Intranet Suche",
  selected_difficulty: ["easy", "medium", "hard"],
  episode: "001",
  type: "search.bar",
  icon: "FileFind2",
  iconProps: {
    variant: "32x32_4",
    css: {
      size: "2.6rem",
    },
  },
  parent: cold_case_unit.id,

  file_keyword_index: [
    {
      title: "Überwachungskamera Bank.jpg",
      file_url: "/resources/images/tc1_foto_bank.jpg",
      keywords: ["foto", "bank", "tom", "ellington", "überwachungskamera", "kamera", "überwachung"],
      icon: "Wangimg128",
      type: "image",
      pre_entered: true,
      pre_entered_text: "Foto Bank Tom Ellington",
      password: null,
    },
    {
      title: "Anzeige Sally Parker.pdf",
      file_url: "/resources/documents/tc1_anzeige_sally_parker.pdf",
      keywords: ["anzeige", "sally", "parker", "elena", "whitmore", "st", "marlowe", "medical", "center", "krankenhaus", "klinik", "arbeit", "anklage", "beschwerde"],
      icon: "FileText",
      type: "pdf",
      pre_entered: false,
      password: null,
    },
    {
      title: "Gestohlene Waffen.pdf",
      file_url: "/resources/documents/tc1_gestohlene_waffen.pdf",
      keywords: ["gestohlene", "waffen", "1986", "diebstahl", "gestohlen", "registrierung"],
      icon: "FileText",
      type: "pdf",
      pre_entered: true,
      pre_entered_text: "Gestohlene Waffen 1986",
      password: null,
    },
  ]

});





export const episode_001 = [
  cold_case_unit,
  papierkorb,
  dna_lookup,
  interview_builders,
  interview_parents_whitmore,
  police_team_yearbook,
  search_bar,
];
